/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'fabric.linkPicker.button.cancel': 'Отмена',
  'fabric.linkPicker.button.insert': 'Вставить',
  'fabric.linkPicker.button.save': 'Сохранить',
  'fabric.linkPicker.clearLink': 'Очистить',
  'fabric.linkPicker.clearLinkText': 'Удалить текст',
  'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {Ничего не найдено} one {Найден {count,number} результат} few {Найдено {count,number} результата} many {Найдено {count,number} результатов} other {Найдено {count,number} результата}}',
  'fabric.linkPicker.linkAriaLabel': 'Введите или вставьте ссылку в поле',
  'fabric.linkPicker.linkInvalid': 'Укажите действительный URL-адрес.',
  'fabric.linkPicker.linkLabel': 'Ссылка',
  'fabric.linkPicker.linkPlaceholder': 'Вставьте ссылку',
  'fabric.linkPicker.linkTextAriaLabel': 'Отображаемый текст ссылки',
  'fabric.linkPicker.linkTextLabel': 'Текст для отображения (необязательно)',
  'fabric.linkPicker.linkTextPlaceholder': 'Текст для отображения',
  'fabric.linkPicker.listTitle.recentlyViewed': 'Недавно просмотренные',
  'fabric.linkPicker.listTitle.results': 'Результаты',
  'fabric.linkPicker.search.error.description': 'Обновите страницу или обратитесь в <a>поддержку Atlassian</a>, если проблема возникнет снова.',
  'fabric.linkPicker.search.error.heading': 'При загрузке данных произошла ошибка.',
  'fabric.linkPicker.search.linkAriaLabel': 'Предложения будут появляться по мере ввода текста в поле',
  'fabric.linkPicker.search.linkLabel': 'Найдите или вставьте ссылку',
  'fabric.linkPicker.search.linkPlaceholder': 'Выполните поиск недавних ссылок или вставьте новую',
  'fabric.linkPicker.search.noResults.description': 'Попробуйте изменить запрос.',
  'fabric.linkPicker.search.noResults.heading': 'Ничего не найдено.',
  'fabric.linkPicker.status.submitting': 'Отправка',
  'fabric.linkPicker.time.message.updated': 'Обновлено {time}',
  'fabric.linkPicker.time.message.viewed': 'Просмотрено {time}',
  'fabric.linkPicker.unhandledError.description': 'Попробуйте перезагрузить страницу.',
  'fabric.linkPicker.unhandledError.heading': 'Произошла ошибка.'
};